import { BUTTON_TYPES } from "./enums";
export var buttonDefaultProps = {
  children: "",
  className: "",
  disabled: false,
  icon: null,
  iconOnRight: false,
  isFullWidth: false,
  isLoading: false,
  minor: false,
  noCcTheme: null,
  spinnerGradientStopClassName: "",
  status: null,
  component: "button",
  type: BUTTON_TYPES.BUTTON,
  variant: null
};